<template>
  <el-dialog custom-class="system_manager_dialog"
             title="添加培训机构"
             :visible.sync="flag"
             :close-on-click-modal="false"
             width="550px">
    <el-form ref="form"
             :rules="rules"
             :model="form"
             label-width="150px">
      <el-form-item label="机构性质"
                    prop="org_type">
        <el-radio-group v-model="form.org_type" @change="createOrg">
          <el-radio label="zuxie">地方足协</el-radio>
          <el-radio label="school">院校/俱乐部</el-radio>
          <el-radio label="other">其它</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="机构级别"
                    prop="org_level">
        <el-radio-group v-model="form.org_level"
                        @change="isShowCity">
          <el-radio label="province">省级</el-radio>
          <el-radio label="city">市级</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="机构所在省份或城市" prop="province_id">
        <el-row v-if="showCity">
          <el-col :span="11">
            <el-form-item prop="province_id">
              <el-select v-model="form.province_id"
                         placeholder="请选择省份"
                         style="width: 100%;"
                         @change="updateCity">
                <el-option
                    v-for="(item, index) in area"
                    :key="index"
                    :label="item.regionName"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">&nbsp;</el-col>
          <el-col :span="11">
            <el-form-item prop="city_id">
              <el-select v-model="form.city_id"
                         placeholder="请选择城市"
                         style="width: 100%;"
                         @change="createOrg">
                <el-option
                    v-for="(item, index) in city"
                    :key="index"
                    :label="item.regionName"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item v-else
                      prop="province_id">
          <el-select v-model="form.province_id"
                     placeholder="请选择省份"
                     style="width: 100%;"
                     @change="updateCity">
            <el-option
                v-for="(item, index) in area"
                :key="index"
                :label="item.regionName"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form-item>
      <el-form-item label="机构全称" prop="name">
        <el-input size="medium"
                  v-model.trim="form.name"
                  placeholder="请输入机构全称"></el-input>
      </el-form-item>
      <el-form-item label="机构简称" prop="org_abbreviation">
        <el-input size="medium"
                  v-model.trim="form.org_abbreviation"
                  placeholder="请输入机构简称"></el-input>
      </el-form-item>
      <el-form-item label="机构编码" prop="org_mark">
        <el-input v-model.trim="form.org_mark"
                  placeholder="请输入两位机构编码" maxlength="2" @change="lose_blur($event)"></el-input>
      </el-form-item>
      <el-form-item label="用户名"
                    prop="username">
        <el-input size="medium"
                  v-model="form.username"
                  placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item size="medium"
                    label="管理员姓名"
                    prop="user_name">
        <el-input v-model.trim="form.user_name"
                  placeholder="请输入管理员姓名"></el-input>
      </el-form-item>
      <el-form-item label="管理员手机"
                    prop="mobile_phone">
        <el-input size="medium"
                  v-model="form.mobile_phone"
                  placeholder="请输入管理员手机"></el-input>
      </el-form-item>
      <!--<el-form-item label="身份证"
                    prop="id_number">
      <el-input size="medium"
                v-model="form.id_number"
                placeholder="请输入正确的身份证信息"></el-input>
      </el-form-item>-->
      <el-form-item label="密码"
                    prop="password">
        <el-input size="medium"
                  v-model="form.password"
                  placeholder="请输入8—16位字母和数字组合"
                  type="password"></el-input>
      </el-form-item>
      <el-form-item label="确认密码"
        prop="password_affirm">
        <el-input size="medium"
          v-model="form.password_affirm"
          placeholder="请确认密码"
          type="password"></el-input>
      </el-form-item>
      <div class="btns">
        <el-button type="primary" :loading="repeatSubmit"  @click="onSubmit">保存</el-button>
        <el-button type="danger" @click="onCancel">取消</el-button>
        <!-- <div class="btn save"
             @click="onSubmit">保存
        </div> -->
        <!-- <div class="btn cancel"
             @click="onCancel">取消
        </div> -->
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import {area_list, area_name} from "@/assets/js/region";
  import {hex_hmac_sha256} from "@/assets/js/sha";
  import {addOrganization} from "@/api/system_manager/api";
  import {getPwdSalt} from "@/api/common/api";

  export default {
    name: "org-add",
    props: ["visible"],
    data() {
      return {
        repeatSubmit: false,
        showCity: false,
        area: area_list,
        city: [],
        phone_flag: false, // 用于标记后台返回错误提示，进行重校验
        phone_msg: "", // 存储后台错误提示
        username_flag: false, // 用于标记后台返回错误提示，进行重校验
        username_msg: "", // 存储后台错误提示
        idCard_flag: false, // 标记后台返回错误提示，进行重校验
        idCard_tips: "", // 后台返回身份证重复提示
        mark_msg:'',
        mark_flag:false,
        form: {
          name: "",
          org_abbreviation: "",
          org_type: "",
          org_level: "",
          org_mark:'',
          province_id: "",
          city_id: "",
          user_name: "",
          mobile_phone: "",
          // id_number: "",
          password: "",
          password_affirm: "",
          username: ""
        },
        rules: {
          name: [
            {required: true, message: '请输入机构全称', trigger: 'blur'},
            // {min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
          ],
          org_abbreviation: [
            {required: true, message: '请输入机构简称', trigger: 'blur'},
            {min: 1, max: 15, message: '长度在 1 到 15 个字符', trigger: 'blur'}
          ],
          org_type: [
            {required: true, message: '请选择机构性质', trigger: 'change'}
          ],
          org_level: [
            {required: true, message: '请选择机构级别', trigger: 'change'}
          ],
          province_id: [
            {required: true, message: '请选择机构所在省', trigger: 'change'}
          ],
          city_id: [
            {required: true, message: '请选择机构所在市', trigger: 'change'}
          ],
          user_name: [
            {required: true, message: '请输入管理员姓名', trigger: 'blur'},
            // {min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
          ],
          username: [
            {
              required: true,
              validator: (rule, val, callback) => {
                if (val) {
                  if (!this.username_flag) {
                    callback();
                  } else {
                    this.username_flag = false;
                    callback(new Error(this.username_msg));
                  }
                } else {
                  callback(new Error('请输入用户名'));
                }
              },
              trigger: 'blur'
            }
          ],
          org_mark:[{
            required: true,
            validator: (rule, val, callback) => {
              if (val  && val.length ===2) {
                if (!this.mark_flag) {
                  callback();
                } else {
                  this.phone_flag = false;
                  callback(new Error(this.mark_msg));
                }
              } else {
                callback(new Error('请输入两位机构编码'));
              }
            },
            trigger: "blur"
          }],
         /*id_number: [
           {
             required: true,
             validator: (rule, val, callback) => {
               if (this.$yioks.idCard_number(val)) {
                 if (!this.idCard_flag) {
                   callback();
                 } else {
                   this.idCard_flag = false;
                   callback(new Error(this.idCard_tips));
                 }
               } else {
                 callback(new Error("请输入正确的身份证信息"));
               }
             },
             trigger: "blur"
           }
         ],*/
          mobile_phone: [
            {
              required: true,
              validator: (rule, val, callback) => {
                if (this.$yioks.mobile_phone(val)) {
                  if (!this.phone_flag) {
                    callback();
                  } else {
                    callback(new Error(this.phone_msg));
                    this.phone_flag = false;
                  }
                } else {
                  callback(new Error('请输入有效的11位手机号'));
                }
              },
              trigger: "blur"
            }
          ],
          password: [
            /*{min: 8, max: 16, message: '8—16位字符，字母（区分大小写）和数字组合', trigger: 'blur'},*/
            {
              required: true,
              validator: (rule, val, callback) => {
                if (this.$yioks.pwd(val)) {
                  callback();
                } else {
                  callback(new Error('8—16位字母（区分大小写）和数字组合'));
                }
              },
              trigger: "blur"
            }
          ],
          password_affirm: [
            /*{min: 8, max: 16, message: '8—16位字符，字母（区分大小写）和数字组合', trigger: 'blur'},*/
            {
              required: true,
              validator: (rule, val, callback) => {
                if (val !== this.form.password) {
                  callback(new Error('两次输入密码不一致'));
                }
                if (this.$yioks.pwd(val)) {
                  callback();
                }else {
                  callback(new Error('8—16位字母（区分大小写）和数字组合'));
                }

              },
              trigger: "blur"
            }
          ]
        }
      };
    },
    computed: {
      flag: {
        set(bool) {
          this.resetForm();
          this.$emit("flag", bool, false);
        },
        get() {
          return this.visible;
        },
      }
    },
    methods: {
      request(data) {
        addOrganization(data)
          .then(res => {
            const {msg, status} = res.data;
            if (Number(status) == 0) {
              this.$emit("flag", false, true);
              this.resetForm();
              // return;
            }
            if (Number(status) == 114) {
              this.phone_msg = msg;
              this.phone_flag = true;
              this.$refs["form"].validateField("mobile_phone");
            }
            if (Number(status) == 402) {
              this.username_msg = msg;
              this.username_flag = true;
              this.$refs["form"].validateField("username");
            }
            if (Number(status) === 513){
              this.mark_flag = true;
              this.mark_msg = msg;
              this.$refs["form"].validateField("org_mark");
            }
           /*if (Number(status) == 415) {
             this.idCard_tips = msg;
             this.idCard_flag = true;
             this.$refs["form"].validateField("id_number");
           }*/
           this.repeatSubmit = false;
          })
          .catch(err => {
            this.repeatSubmit = false;
            console.error(err);
          });
      },
      createOrg() {
        if(this.form.org_type != "zuxie") {return;}
        if(this.form.org_level == "") {return;}
        if(this.form.province_id == "") {return;}
        let name = area_name[this.form.province_id];
        let subName = area_name[this.form.province_id];
        if(this.form.city_id != ""){
          name = area_name[this.form.city_id];
          subName = area_name[this.form.city_id];
        }
        const reg = /省|维吾尔|回族|自治区|特别行政区|地区|黎族|自治县|土家族|朝鲜族|壮族|布依族|苗族|傣族|景颇族|藏族|白族|彝族|哈尼族|傈僳族|侗族|羌族|蒙古族|自治州/g;
        name += "足球协会";
        subName = subName.replace(reg, "") + "足协";
        this.$set(this.form, "name", name);
        this.$set(this.form, "org_abbreviation", subName);
        this.$refs["form"].validateField("name");
        this.$refs["form"].validateField("org_abbreviation");
      },
      updateCity() {
        this.city = this.$yioks.updateCity(this.form.province_id, this.area);
        if (this.form.org_level == "city") {
          this.$set(this.form, "city_id", this.city[0].id);
        }
        this.createOrg();
      },
      isShowCity() {
        this.showCity = Boolean(this.form.org_level == "city");
        if(!this.showCity){
          this.$set(this.form, "city_id", "");
        }
        this.createOrg();
      },
      onSubmit() {
        if(this.repeatSubmit){return;}
        this.repeatSubmit = true;
        this.$refs["form"].validate((valid) => {
          if (valid) {
            // alert('submit!');
            getPwdSalt({})
              .then((res) => {
                if(Number(res.data.status) === 0) {
                  const {regist_salt} = res.data.result.data;
                  const pwd = hex_hmac_sha256(regist_salt, this.form.password).toUpperCase();
                  const pwd_affirm = hex_hmac_sha256(regist_salt, this.form.password_affirm).toUpperCase();
                  // 解决密码闪动
                  const data = {...this.form, password: pwd, regist_salt: regist_salt,password_affirm: pwd_affirm};
                  this.request(data);
                  return;
                }
                throw new Error(res);
              })
              .catch((err) => {
                this.repeatSubmit = false;
                console.error(err);
              })
          } else {
            this.repeatSubmit = false;
            console.log('error submit!!');
            return false;
          }
        });
      },
      onCancel() {
        this.flag = false;
      },
      resetForm() {
        this.$refs["form"].resetFields();
        this.showCity = false;
        // 解决先选省市后选级别，无法完全重置表单的bug
        this.$set(this.form, "province_id", "");
        this.$set(this.form, "city_id", "");
      },
      lose_blur(val){
        this.form.org_mark=this.$yioks.privateCode(val) ? this.$yioks.privateCode(val) :''
      },
    }
  }
</script>
<style lang="stylus" scoped>
@import "~@/assets/css/variable";
.el-button--danger
  background-color $color_err
</style>
